<form *ngIf="documentTypes; else spinner" [formGroup]="form" (ngSubmit)="submit()">
  <app-input
    [fullWidth]="true"
    [formGroup]="form"
    [isSubmitted]="isSubmitted"
    [options]="inputs.DocumentNumber"></app-input>
  <lib-mt-selector
    [fullWidth]="true"
    [formGroup]="form"
    [isSubmitted]="isSubmitted"
    [options]="inputs.Type"></lib-mt-selector>

  <div class="container-pickers">
    <div class="pickers">
      <label class="form__label">{{ 'C_F_VALIDITY_DATE' | translate }}</label>
      <fd-date-picker
        [type]="'single'"
        [options]="inputs.ExpiryDate"
        [state]="isValidExpiry() ? 'valid' : 'invalid'"
        [format]="actualFormat"
        formControlName="ExpiryDate"
        [useValidation]="true"
        [locale]="translationsService.currentLanguage$.value"
        [activeDisableDays]="true"
        [dayDisableStart]="expirationStart"
        [dayDisableEnd]="currentDate"></fd-date-picker>
    </div>
    <div class="pickers">
      <label class="form__label">{{ 'C_F_DELIVERY_DATE' | translate }}</label>
      <fd-date-picker
        [type]="'single'"
        [options]="inputs.DeliveryDate"
        [state]="isValidDelivery() ? 'valid' : 'invalid'"
        [format]="actualFormat"
        formControlName="DeliveryDate"
        [useValidation]="true"
        [locale]="translationsService.currentLanguage$.value"
        [activeDisableDays]="true"
        [dayDisableStart]="currentDate"
        [dayDisableEnd]="expeditionEnd"></fd-date-picker>
    </div>
  </div>
  <lib-mt-country-picker
    [fullWidth]="true"
    [formGroup]="form"
    [customCountries]="currentTranslateCountries"
    [currentTranslatedCountries]="currentTranslateCountries"
    [options]="inputs.IdDeliveryCountry"></lib-mt-country-picker>
  <label class="form__label">{{ 'M_PAC_ENROLLMENT_SMILE_ACCOUNT_DOCS_IMAGES' | translate }}</label>
  <div class="contain-images">
    <app-image-uploader
      [fullWidth]="true"
      *ngIf="!readonly"
      [formGroup]="form"
      [isSubmitted]="isSubmitted"
      [options]="inputs.file1"></app-image-uploader>
    <app-image-uploader
      [fullWidth]="true"
      *ngIf="!readonly"
      [formGroup]="form"
      [isSubmitted]="isSubmitted"
      [options]="inputs.file2"></app-image-uploader>
  </div>
</form>
<ng-template #spinner>
  <app-infinite-scroll-loader></app-infinite-scroll-loader>
</ng-template>
